export const ACTION_RESET = 'FETCH_HKMBDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_HKMBDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_HKMBDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_HKMBDATALIST_ERROR';
